import React, { Component } from 'react';
import { connect } from 'react-redux';
import TagListViewModal from '../../../../views/app/common/modal/TagListViewModal/TagListViewModal';
import withModal from '../../../../lib/hoc/withModal';
import { appActions } from '../../../../store/modules/app';

class TagListViewModalContainer extends Component {
  /**
   *  모달 닫기
   */
  closeModal = () => {
    const { toggleModal } = this.props;
    toggleModal({ name: 'tagListViewModal' });
  };

  render() {
    const { isOpen, data } = this.props;
    return <TagListViewModal isOpen={isOpen} data={data} closeModal={this.closeModal} />;
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.app.tagListViewModal.isOpen,
    data: state.app.tagListViewModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: appActions.appToggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(TagListViewModalContainer));
